import { Component } from '@angular/core';

@Component({
  selector: 'cs-under-construction',
  standalone: false,
  templateUrl: './under-construction.component.html'
})
export class UnderConstructionComponent {}
